<template>
  <div class="viaje-info-card">
    <div class="viaje-nombre text-primary">{{ viaje.nombre }}</div>
    <div class="viaje-detalles">
      <div class="detalle-item">
        <LocationIcon :size="20" color="var(--bs-primary)" />
        <span class="text-primary">{{ viaje.lugarExperiencia }}</span>
      </div>
      <div class="detalle-item">
        <CalendarIcon :size="20" color="var(--bs-primary)" />
        <span class="text-primary"> {{ formatDate(viaje.fechaInicio) }} - {{ formatDate(viaje.fechaFin) }} </span>
      </div>
    </div>
  </div>
</template>

<script setup>
  import LocationIcon from '@/components/Icons/LocationIcon.vue';
  import CalendarIcon from '@/components/Icons/CalendarIcon.vue';
  import { formatDate } from '@/helpers/dateUtiles';

  defineProps({
    viaje: {
      type: Object,
      required: true,
    },
  });
</script>

<style lang="scss" scoped>
  .viaje-info-card {
    background-color: #f9f7f8;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);

    .viaje-nombre {
      font-size: 22px;
      font-weight: 700;
      margin-bottom: 16px;
    }

    .viaje-detalles {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .detalle-item {
      display: flex;
      align-items: center;
      gap: 8px;

      span {
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
</style>
